// extracted by mini-css-extract-plugin
module.exports = {"juce_select":"Item_juce_select__2xLji","quantity":"Item_quantity__2uY_m","btn":"Item_btn__2jwVM","plus":"Item_plus__1sHWc","minus":"Item_minus__2p-EQ"};